import { createSlice } from "@reduxjs/toolkit";

const dataSlice = createSlice({
  name: "data",
  initialState: {
    datasets: {},
    filters: {},
    loading: false,
    error: null,
    pagination: {}
  },
  reducers: {
    fetchDataRequest: (state, action) => {
      const { datasetName } = action.payload;
      state.loading = true;
      state.error = null;
      if (!state.datasets[datasetName]) {
        state.datasets[datasetName] = [];
      }
    },
    fetchDataSuccess: (state, action) => {
      const { datasetName, data, total, page, totalPages } = action.payload;
      state.loading = false;
      state.datasets[datasetName] = data;
      state.pagination[datasetName] = {
        total,
        page,
        totalPages
      };
    },
    fetchDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchFiltersRequest: (state, action) => {
      const datasetName = action.payload;
      state.loading = true;
      state.error = null;
      if (!state.filters[datasetName]) {
        state.filters[datasetName] = [];
      }
    },
    fetchFiltersSuccess: (state, action) => {
      const { datasetName, data } = action.payload;
      state.loading = false;
      state.filters[datasetName] = data;
    },
    fetchFiltersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const {
  fetchDataRequest,
  fetchDataSuccess,
  fetchDataFailure,
  fetchFiltersRequest,
  fetchFiltersSuccess,
  fetchFiltersFailure
} = dataSlice.actions;
export default dataSlice.reducer;